/**
 * Reads a single cookie value by name, or undefined when unavailable
 * (no document, empty cookie jar, or the cookie is not set).
 */
export function getCookie(name: string): string | undefined {
    if (typeof document === "undefined" || !document.cookie) {
        return undefined;
    }
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const match = document.cookie.match(new RegExp("(?:^|; )" + escaped + "=([^;]*)"));
    if (!match) {
        return undefined;
    }
    try {
        return decodeURIComponent(match[1]);
    } catch {
        // decodeURIComponent throws a URIError on malformed percent-encoding
        // (e.g. a stray "%" written by another script). getMetaCookies runs
        // during FORM_SUBMIT, so never let a bad tracking cookie break the lead:
        // fall back to the raw value (fbp/fbc are normally not percent-encoded).
        return match[1];
    }
}

/**
 * Meta's browser cookies used for Conversions API match quality and dedup:
 * `_fbp` (browser id) and `_fbc` (click id). Forwarded to the backend with the
 * lead so the server-side CAPI event carries the same signals as the browser
 * pixel. Only keys that are actually present are returned.
 */
export function getMetaCookies(): { fbp?: string; fbc?: string } {
    const fbp = getCookie("_fbp");
    const fbc = getCookie("_fbc");
    return {
        ...(fbp ? { fbp } : {}),
        ...(fbc ? { fbc } : {}),
    };
}
